import styled, { css } from 'styled-components';

function colorStyle({
  $type,
  theme
}) {
  var _theme$message$$type;
  const color = $type ? (_theme$message$$type = theme.message[$type]) === null || _theme$message$$type === void 0 ? void 0 : _theme$message$$type.color : null;
  return color ? css(["color:", ";"], color) : '';
}
const StyledMessageHeader = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30045578__sc-1w57dq4-0"
})(["> h1,> h2,> h3,> h4,> h5,> h6{margin:0;padding-bottom:", ";font-weight:500;}", ""], ({
  theme
}) => theme.spacing.micro, colorStyle);
StyledMessageHeader.displayName = 'StyledMessageHeader';
var MessageHeader = StyledMessageHeader;

export { MessageHeader as M };
//# sourceMappingURL=MessageHeader-a5ee98ea.js.map
